import { cva } from 'class-variance-authority';

export const cvaRentBegin = cva(
  ['RentBeginStyles-cvaRentBegin', 'flex flex-col gap-1.2'],
  {
    variants: {
      absolute: {
        true: [''],
        false: [''],
      },
    },
    defaultVariants: {
      absolute: true,
    },
  }
);
